import { Slide } from "react-reveal";
import FaqCardList from "../reusables/FaqCardList";
import FaqCard from "../reusables/FaqCard";
import OtherFAQs from "../reusables/OtherFAQs";

const CCTVSecurityFaqsBody = () => {
  return (
    <section className="faqs section-spacing-100">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head center width-600 margin-auto section-spacing-50 no-padding-top">
              <p className="section-tag boldTitle">FAQS</p>
              <Slide top>
                <h2 className="section-title ntuna-text-fill">
                  Frequently Asked Questions
                </h2>
              </Slide>
            </div>
            <div className="section-body">
              <ul className="faqs-container width-600 margin-auto">
                <FaqCardList faq="How do I know what type of CCTV system I need?">
                  <p>You don’t have to figure that out yourself. We assess:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Your premises</span>
                    </li>
                    <li>
                      <span>Risk areas</span>
                    </li>
                    <li>
                      <span>Coverage needs</span>
                    </li>
                  </ul>
                  <p>
                    You get a system designed specifically for your
                    environment—not guesswork.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will there be blind spots or areas not covered?">
                  <p>No. We:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Map your entire space</span>
                    </li>
                    <li>
                      <span>Strategically position cameras</span>
                    </li>
                    <li>
                      <span>Verify coverage during testing</span>
                    </li>
                  </ul>
                  <p>You get full visibility with no critical gaps.</p>
                </FaqCardList>
                <FaqCardList faq="How clear will the camera footage be?">
                  <p>
                    Clarity depends on your needs, and we guide you accordingly.
                    We provide:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>HD / Full HD / 4K options</span>
                    </li>
                    <li>
                      <span>Night vision and low-light performance</span>
                    </li>
                  </ul>
                  <p>
                    You get clear, usable footage for monitoring and evidence.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Can I view my cameras remotely?">
                  <p>Yes. You will be able to:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>
                        Monitor live footage from your phone or computer
                      </span>
                    </li>
                    <li>
                      <span>Access recordings</span>
                    </li>
                    <li>
                      <span>Receive alerts</span>
                    </li>
                  </ul>
                  <p>You stay in control from anywhere at any time.</p>
                </FaqCardList>
                <FaqCardList faq="What happens if there is no power?">
                  <p>
                    Your system can be configured with backup solutions such as:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>UPS systems</span>
                    </li>
                    <li>
                      <span>Power stabilization</span>
                    </li>
                  </ul>
                  <p>
                    Your security system continues running even during power
                    outages.
                  </p>
                </FaqCardList>
                <FaqCardList faq="How long is footage stored?">
                  <p>
                    Storage depends on your setup and needs. We configure based
                    on:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Number of cameras</span>
                    </li>
                    <li>
                      <span>Recording type</span>
                    </li>
                    <li>
                      <span>Storage capacity</span>
                    </li>
                  </ul>
                  <p>
                    Typically, footage can be stored from several days to weeks
                    or more, based on your needs.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Can I retrieve past footage easily?">
                  <p>Yes. You can:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Search by date and time</span>
                    </li>
                    <li>
                      <span>Replay recordings</span>
                    </li>
                    <li>
                      <span>Export footage when needed</span>
                    </li>
                  </ul>
                  <p>Access to your footage is simple, fast, and reliable.</p>
                </FaqCardList>
                <FaqCardList faq="Will the installation damage my walls or space?">
                  <p>No. We ensure:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Clean, professional installation</span>
                    </li>
                    <li>
                      <span>Minimal disruption</span>
                    </li>
                    <li>
                      <span>Proper cable management</span>
                    </li>
                  </ul>
                  <p>Your space remains neat and professionally finished.</p>
                </FaqCardList>
                <FaqCardList faq="Can the system work at night or in low light?">
                  <p>Yes. We install cameras with:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Infrared night vision</span>
                    </li>
                    <li>
                      <span>Low-light performance</span>
                    </li>
                  </ul>
                  <p>Your premises remain fully monitored 24/7.</p>
                </FaqCardList>
                <FaqCardList faq="Is the system secure from hacking or unauthorized access?">
                  <p>Yes. We implement:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Secure configurations</span>
                    </li>
                    <li>
                      <span>Strong access controls</span>
                    </li>
                    <li>
                      <span>Network protection measures</span>
                    </li>
                  </ul>
                  <p>
                    Your system is protected from unauthorized access and
                    digital threats.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Can I control who accesses certain areas of my premises?">
                  <p>Yes. With access control systems, you can:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Restrict entry</span>
                    </li>
                    <li>
                      <span>Track movement</span>
                    </li>
                    <li>
                      <span>Assign permissions</span>
                    </li>
                  </ul>
                  <p>
                    You gain full control over who enters and exits your
                    property.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will the system be difficult to use?">
                  <p>No. You will be trained on:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Monitoring</span>
                    </li>
                    <li>
                      <span>Playback</span>
                    </li>
                    <li>
                      <span>Basic controls</span>
                    </li>
                  </ul>
                  <p>
                    The system is simple and easy to use, even without technical
                    knowledge.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Do I need internet for the CCTV system to work?">
                  <p>No.</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>The system records locally without internet</span>
                    </li>
                    <li>
                      <span>Internet is only required for remote access</span>
                    </li>
                  </ul>
                  <p>Your security works even offline.</p>
                </FaqCardList>
                <FaqCardList faq="What maintenance does the system require?">
                  <p>Minimal. We recommend:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Periodic checks</span>
                    </li>
                    <li>
                      <span>Cleaning cameras</span>
                    </li>
                    <li>
                      <span>System updates</span>
                    </li>
                  </ul>
                  <p>
                    With proper care, your system remains reliable long-term.
                  </p>
                </FaqCardList>
                <FaqCardList faq="What happens if something stops working?">
                  <p>Support is available. We:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Diagnose issues</span>
                    </li>
                    <li>
                      <span>Fix faults</span>
                    </li>
                    <li>
                      <span>Provide guidance</span>
                    </li>
                  </ul>
                  <p>You are not left alone after installation.</p>
                </FaqCardList>
                <FaqCardList faq="Can the system be expanded later?">
                  <p>Yes. Your system is designed to:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Add more cameras</span>
                    </li>
                    <li>
                      <span>Increase storage</span>
                    </li>
                    <li>
                      <span>Upgrade features</span>
                    </li>
                  </ul>
                  <p>You can scale as your needs grow.</p>
                </FaqCardList>
                <FaqCardList faq="How long does installation take?">
                  <p>It depends on:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Size of the premises</span>
                    </li>
                    <li>
                      <span>Number of cameras</span>
                    </li>
                    <li>
                      <span>Complexity of the setup</span>
                    </li>
                  </ul>
                  <p>Timelines are clearly communicated before work begins.</p>
                </FaqCardList>
                <FaqCardList faq="Is CCTV enough, or do I also need access control?">
                  <p>It depends on your needs.</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>CCTV → monitoring</span>
                    </li>
                    <li>
                      <span>Access control → restriction & tracking</span>
                    </li>
                  </ul>
                  <p>
                    Many setups benefit from combining both for full security
                    coverage.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will the system actually help prevent theft or incidents?">
                  <p>Yes. CCTV systems:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Deter unauthorized activity</span>
                    </li>
                    <li>
                      <span>Provide evidence</span>
                    </li>
                    <li>
                      <span>Improve accountability</span>
                    </li>
                  </ul>
                  <p>You gain both prevention and protection.</p>
                </FaqCardList>
                <FaqCardList faq="Can I monitor multiple locations from one place?">
                  <p>Yes. You can:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>View multiple sites</span>
                    </li>
                    <li>
                      <span>Manage systems centrally</span>
                    </li>
                  </ul>
                  <p>Ideal for businesses with multiple locations.</p>
                </FaqCardList>
                <FaqCardList faq="Will I be able to understand what’s happening from the footage?">
                  <p>Yes. With proper setup:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Camera positioning</span>
                    </li>
                    <li>
                      <span>Image clarity</span>
                    </li>
                    <li>
                      <span>Coverage planning</span>
                    </li>
                  </ul>
                  <p>
                    You get meaningful, actionable visibility—not useless
                    footage.
                  </p>
                </FaqCardList>
                <FaqCardList faq="What makes your CCTV and security solution different?">
                  <p>We don’t just install cameras. We:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Plan strategically</span>
                    </li>
                    <li>
                      <span>Design complete systems</span>
                    </li>
                    <li>
                      <span>Ensure reliability and usability</span>
                    </li>
                  </ul>
                  <p>
                    You get a complete security solution—not just equipment.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Is this suitable for both small and large properties?">
                  <p>Yes. Solutions are tailored for:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Homes</span>
                    </li>
                    <li>
                      <span>Offices</span>
                    </li>
                    <li>
                      <span>Construction sites</span>
                    </li>
                    <li>
                      <span>Schools</span>
                    </li>
                    <li>
                      <span>Large facilities</span>
                    </li>
                  </ul>
                  <p>The system is scaled to your specific needs.</p>
                </FaqCardList>
                <FaqCardList faq="Do I need to understand technical details to get started?">
                  <p>No. We guide you through:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Requirements</span>
                    </li>
                    <li>
                      <span>Recommendations</span>
                    </li>
                    <li>
                      <span>Setup</span>
                    </li>
                  </ul>
                  <p>You can make decisions without technical complexity.</p>
                </FaqCardList>
                <FaqCardList faq="What is the final result after installation?">
                  <p>You get:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Full visibility of your premises</span>
                    </li>
                    <li>
                      <span>Controlled access</span>
                    </li>
                    <li>
                      <span>Reliable system performance</span>
                    </li>
                  </ul>
                  <p>
                    Most importantly, you gain peace of mind knowing your
                    property is protected.
                  </p>
                </FaqCardList>
                <FaqCardList faq="How do I/we get started?">
                  <p>
                    Simply{" "}
                    <a
                      href="/contacts"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      contact us
                    </a>{" "}
                    or book a{" "}
                    <a href="/#" target="_blank" rel="noopener noreferrer">
                      consultation
                    </a>
                    . We’ll:
                  </p>
                  <ul className="faq-olist">
                    <li>
                      <span>Understand your needs</span>
                    </li>
                    <li>
                      <span>Agree on fee so you can make initial deposit</span>
                    </li>
                    <li>
                      <span>Begin setups</span>
                    </li>
                  </ul>
                </FaqCardList>

                <FaqCard
                  faq="Do you offer payment plans?"
                  answer="Yes. We offer flexible payment plans to make it easier for clients to invest in the efficiency and growth of their businesses and institutions."
                />
              </ul>
            </div>
            <OtherFAQs/>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CCTVSecurityFaqsBody;
